import { FilterOptionType } from '@repo/common/components/Filter';
import {
	DEFAULT_FILTER_OPTIONS_WITH_DQS,
	FILTER_OPTIONS_DIVIDER,
} from '@repo/common/components/Filter/constants';
import { useMemo } from 'react';
import { useDataQualityAccess, useSuspenseFeatureAccess } from '../../api';
import { useAiWorkspaceSettingEnabled } from '../../hooks/useAiWorkspaceSettingEnabled';
import { useFeatureFlags } from '../../utils/featureFlags';
import { CATALOG_TYPE_FILTER_OPTION, FILTER_OPTIONS_CONFIG } from './constants';

export function useCatalogFilter() {
	const enableAi = useAiWorkspaceSettingEnabled();
	const { collectionsAccess } = useSuspenseFeatureAccess();
	const dqsEnabled = useDataQualityAccess();
	const { policyV2 } = useFeatureFlags();

	return useMemo(() => {
		const removedFilters = [
			...(!collectionsAccess ? [FilterOptionType.COLLECTIONS] : []),
			...(!dqsEnabled ? [FilterOptionType.DATA_QUALITY] : []),
			...(!policyV2
				? [FilterOptionType.POLICY, FilterOptionType.HAS_POLICY_ISSUE]
				: []),
		];

		let options = DEFAULT_FILTER_OPTIONS_WITH_DQS;

		if (enableAi) {
			options = [FilterOptionType.AI, FILTER_OPTIONS_DIVIDER, ...options];
		}

		return options
			.filter((option) => {
				if (option === FILTER_OPTIONS_DIVIDER) {
					return true;
				}
				return !removedFilters.includes(option as FilterOptionType);
			})
			.map((option) => {
				if (option === FILTER_OPTIONS_DIVIDER) {
					return FILTER_OPTIONS_DIVIDER;
				}

				if (option === FilterOptionType.NATIVE_TYPE) {
					// Override the native_type filter to only show types enabled for the catalog.
					return CATALOG_TYPE_FILTER_OPTION;
				}

				return FILTER_OPTIONS_CONFIG[option];
			});
	}, [dqsEnabled, enableAi, collectionsAccess, policyV2]);
}
